import { Howl } from 'howler';
import { loaders } from 'pixi.js';
import { AudioSpriteMap } from '../../System/Audio/AudioSpriteMap';
const prodPath = window.location.pathname.replace('index.html', '');

export default function HowlerMiddleware(
    resource: PIXI.loaders.Resource,
    next: any
) {
    if (!resource) return next();

    if (resource.extension === 'json') {
        if (!resource.data || !resource.data.urls || !resource.data.sprite) {
            return next();
        }
    } else if (!['wav', 'ogg', 'mp3', 'mpeg'].includes(resource.extension)) {
        return next();
    }

    // @ts-ignore
    resource._setFlag(loaders.Resource.STATUS_FLAGS.LOADING, true);
    // @ts-ignore
    let options: any;

    if (resource.extension === 'json') {
        const src = resource.data.urls.map((path: string) => prodPath + path);

        // Audio sprite data from JSON.
        options = {
            src,
            sprite: resource.data.sprite,
        };

        // Prepare sprite lookup.
        AudioSpriteMap[resource.name] = [];
        for (let key in resource.data.sprite) {
            AudioSpriteMap[resource.name].push(key);
        }
    } else {
        // Regular audio files.
        options = JSON.parse(JSON.stringify(resource.metadata));
        options.src = [resource.url];
    }

    options.html5 = false;

    options.onload = () => {
        next();
    };
    options.onloaderror = (id: any, message: any) => {
        // tslint:disable-next-line: no-console
        console.error(resource);

        // @ts-ignore
        resource._setFlag(loaders.Resource.STATUS_FLAGS.COMPLETE, false);
        resource.abort(message);
        next();
    };

    resource.data = new Howl(options);
}
